// src/environments/environment.dev.ts
export const environment = {
  production: false,
  appVersion: '2026.10.26.190257',
  enableGalleryUpload: true,
  showPoseDebugInfo: true,

  firebase: {
    apiKey: 'AIzaSyBqenVMJTEVPYWR6elDy1wTdD5Dt0ZA_1A',
    authDomain:
      typeof window !== 'undefined' &&
      window.location.hostname === 'app.movfascia.com'
        ? 'app.movfascia.com'
        : 'movfascia-22aa3.web.app',
    projectId: 'movfascia-22aa3',
    storageBucket: 'movfascia-22aa3.firebasestorage.app',
    messagingSenderId: '1091509614763',
    appId: '1:1091509614763:web:ee3cc2eb2eb37b80771fee',
  },

  evaluationPhotoStorageBucket:
    'gs://movfascia-22aa3-evaluation-photos',

  websiteUrl: 'https://movfascia.com/',
  blogUrl: 'https://movfascia.com/blog',
  termsUrl: 'https://movfascia.com/terms',
  privacyUrl: 'https://movfascia.com/privacy',
  supportUrl: 'https://movfascia.com/support',
  legalNoticeUrl: 'https://movfascia.com/aviso-legal.html',

  // Chave real do Stripe (Subscription)
  stripePublicKey: 'pk_test_51XXXXXX',

  // =====================================================
  // 🔥 FIREBASE REAL DEV
  // =====================================================
  apiUrl: 'https://southamerica-east1-movfascia-22aa3.cloudfunctions.net',

  firebaseAuthEmulatorHost: '',
  firebaseFirestoreEmulatorHost: '',
  firebaseFirestoreEmulatorPort: 0,
  firebaseStorageEmulatorHost: '',
  firebaseStorageEmulatorPort: 0
};
